export const syncCallCompleted = (message, reducers, data, connection) => {
  const { eventsDispatch } = reducers;
  eventsDispatch({ type: 'CALL_COMPTETED', payload: message.payload });
};
